// extracted by mini-css-extract-plugin
export default {"root":"CartIcon_root__jxIJi","icon":"CartIcon_icon__nkbAv","badge":"CartIcon_badge__iJ3tz","srOnly":"CartIcon_srOnly__uAnW9"};